import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform, Type } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { EmployeeDocumentOriginEnum } from "@/core/features/employee-documents/employee-document-origin.enum";
import { EmployeeDocumentReviewStatusEnum } from "@/core/features/employee-documents/employee-document-review-status.enum";
import { UserDto } from "@/core/features/users/user.dto";

export class EmployeeDocumentVersionDto extends BaseEntityDto {
  documentId: string;
  versionNumber: number;
  storageKey: string;
  filename: string;
  mimetype: string;
  size: number;
  contentHash: string;
  origin: EmployeeDocumentOriginEnum;
  reviewStatus: EmployeeDocumentReviewStatusEnum;
  reviewMessage?: string | null;
  reviewedById?: string | null;

  @Type(() => UserDto)
  reviewedBy?: UserDto | null;

  @Transform(({ value }) => parseApiDate(value))
  reviewedAt?: Date | null;
}
